import { OrgTypes } from '@mode/shared/contract-common';
import { Action, ActionReducerMap, createReducer, on } from '@ngrx/store';
import * as AdminActions from './admin.actions';

export const adminFeatureKey = 'admin';

export interface State {
  admins: ReadonlyArray<OrgTypes.Admin>;
  isLoading: boolean;
  isComplete: boolean;
  error: Error | null;
}

export const initialState: State = {
  admins: [],
  isLoading: false,
  isComplete: false,
  error: null,
};

const adminsReducer = createReducer(
  initialState.admins,
  on(AdminActions.loadAdmins, (state) => state),
  on(AdminActions.loadAdminsSuccess, (state, action) => action.admins),
  on(AdminActions.loadAdminsFailure, (state, action) => [])
);

const isLoadingReducer = createReducer(
  initialState.isLoading,
  on(AdminActions.loadAdmins, (state) => true),
  on(AdminActions.loadAdminsSuccess, (state, action) => false),
  on(AdminActions.loadAdminsFailure, (state, action) => false)
);

const isCompleteReducer = createReducer(
  initialState.isComplete,
  on(AdminActions.loadAdmins, (state) => false),
  on(AdminActions.loadAdminsSuccess, (state, action) => true),
  on(AdminActions.loadAdminsFailure, (state, action) => true)
);

const errorReducer = createReducer(
  initialState.error,
  on(AdminActions.loadAdmins, (state) => null),
  on(AdminActions.loadAdminsSuccess, (state, action) => null),
  on(AdminActions.loadAdminsFailure, (state, action) => action.error)
);

export const reducer: ActionReducerMap<State> = {
  isComplete: isCompleteReducer,
  isLoading: isLoadingReducer,
  admins: adminsReducer,
  error: errorReducer,
};
